import gatewayFetchV2 from '@patrianna/gateway/gatewayFetch/indexV2'
import type { ServiceDependenciesOptions as SharedStoreServiceDependenciesOptions } from '@patrianna-payments/shared-store/payments/store/types'
import type { ServiceDependenciesOptions as SharedStoreRedeemServiceDependenciesOptions } from '@patrianna-payments/shared-store/redeem/store/types'

import gatewayInstance, { payment, api, gatewayErrorInstance, fraud } from 'services/gateway'

export type ServiceDependenciesOptions = Omit<SharedStoreServiceDependenciesOptions, 'payment'> &
  Omit<SharedStoreRedeemServiceDependenciesOptions, 'payment'> & {
    payment: typeof payment &
      SharedStoreServiceDependenciesOptions['payment'] &
      SharedStoreRedeemServiceDependenciesOptions['payment']
    gateway: typeof gatewayInstance
    fetch: typeof gatewayFetchV2
    api: typeof api
    fraud: typeof fraud
  }

export type ServiceFraudDependencies = {
  errorHandler: SharedStoreServiceDependenciesOptions['errorHandler']
  fraud: typeof fraud
}

/*
  Use this to inject API dependencies to redux-store
  if redux-store ( thunk ) is not available in the context
  use this object directly

  Example:
  import { serviceDependencies } from 'src/services'

  serviceDependencies.gateway.emit<SomeRequest>({ type: 'SomeRequest' })
  serviceDependencies.errorHandler(err, data)

  In the next refactoring, we are going to remove "gatewayFetch" and will use
  "serviceDependencies.fetch" instead
 */
export const serviceDependencies: ServiceDependenciesOptions = {
  gateway: gatewayInstance,
  errorHandler: gatewayErrorInstance.errorHandler.bind(
    gatewayErrorInstance,
  ) as SharedStoreServiceDependenciesOptions['errorHandler'],
  fetch: gatewayFetchV2,
  api,
  fraud,
  payment: payment as ServiceDependenciesOptions['payment'],
}

export const serviceFraudDependencies: ServiceFraudDependencies = {
  fraud,
  errorHandler: gatewayErrorInstance.errorHandler.bind(
    gatewayErrorInstance,
  ) as SharedStoreServiceDependenciesOptions['errorHandler'],
}
